module.exports = __webpack_public_path__ + "img/DJ.610675b3.png";